import { Box } from "@mui/material";
import { Chessboard } from "react-chessboard";
import { buildChessboardOptions, type ChesslaBoardOptions } from "./chessboard-options";
import { layoutTokens } from "@/shared/theme";

export interface ChesslaBoardProps extends ChesslaBoardOptions {
  width?: number | string;
}

export const ChesslaBoard = ({ width = "100%", ...input }: ChesslaBoardProps) => {
  const options = buildChessboardOptions(input);
  return (
    <Box
      sx={{
        width,
        maxWidth: "100%",
        aspectRatio: "1 / 1",
        minWidth: 0,
        overflow: "hidden",
        '& [data-square] [role="button"]:focus': { outline: "none" },
        '& [data-square] [role="button"]:focus-visible': {
          outline: (theme) => `${layoutTokens.dividerBorder * 2}px solid ${theme.palette.primary.main}`,
          outlineOffset: -layoutTokens.dividerBorder * 2,
        },
      }}
    >
      <Chessboard options={options} />
    </Box>
  );
};
